module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "option",
    attrs: {
      "href": "javascript:;",
      "title": "Exportar"
    },
    on: {
      "click": function($event) {
        _vm.modalOpen('code');
        _vm.codeSetupBox(_vm.box)
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-import"
  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.export')) + " Box\n")])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ff858dba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/ExportBox.vue
 ** module id = 930
 ** module chunks = 1
 **/